// extracted by mini-css-extract-plugin
export var altBookInfo = "roomsummary-module--alt-book-info--+NHi7";
export var roomBook = "roomsummary-module--room-book--lKI-7";
export var roomFeatures = "roomsummary-module--room-features--6i0NC";
export var roomSummary = "roomsummary-module--room-summary--uMe-a";
export var summaryContainer = "roomsummary-module--summary-container--o48gU";
export var summaryImage = "roomsummary-module--summary-image--DcDkR";
export var summaryInfo = "roomsummary-module--summary-info--+75NN";